import { render, staticRenderFns } from "./detail_handle.vue?vue&type=template&id=382a91a1&scoped=true"
import script from "./detail_handle.vue?vue&type=script&lang=js"
export * from "./detail_handle.vue?vue&type=script&lang=js"
import style0 from "./detail_handle.vue?vue&type=style&index=0&id=382a91a1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a91a1",
  null
  
)

export default component.exports